export default __webpack_public_path__ + "static/media/utracker.dfe9ae48.png";